import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7c1ed1b4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_2 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Change Details\n          ")
], -1));
const _hoisted_4 = { class: "col-span-6" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "effectiveDate",
    class: "block text-sm font-medium text-gray-700"
}, "Effective date: *", -1));
const _hoisted_6 = ["value", "disabled"];
const _hoisted_7 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_8 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "\n              Type of amendment: *\n            ", -1));
const _hoisted_10 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_11 = { class: "mt-4 space-y-4" };
const _hoisted_12 = { class: "flex items-start" };
const _hoisted_13 = { class: "h-5 flex items-center" };
const _hoisted_14 = ["checked", "disabled"];
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "amendmentType",
        class: "font-medium text-gray-700"
    }, "Allowance Change")
], -1));
const _hoisted_16 = { class: "flex items-start" };
const _hoisted_17 = { class: "h-5 flex items-center" };
const _hoisted_18 = ["checked", "disabled"];
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "amendmentType",
        class: "font-medium text-gray-700"
    }, "Business Structure Change")
], -1));
const _hoisted_20 = { class: "flex items-start" };
const _hoisted_21 = { class: "h-5 flex items-center" };
const _hoisted_22 = ["checked", "disabled"];
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "amendmentType",
        class: "font-medium text-gray-700"
    }, "Contract change")
], -1));
const _hoisted_24 = { class: "flex items-start" };
const _hoisted_25 = { class: "h-5 flex items-center" };
const _hoisted_26 = ["checked", "disabled"];
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "amendmentType",
        class: "font-medium text-gray-700"
    }, "Entity / Cost Centre Change")
], -1));
const _hoisted_28 = { class: "flex items-start" };
const _hoisted_29 = { class: "h-5 flex items-center" };
const _hoisted_30 = ["checked", "disabled"];
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "amendmentType",
        class: "font-medium text-gray-700"
    }, "Hours/Work Pattern Change")
], -1));
const _hoisted_32 = { class: "flex items-start" };
const _hoisted_33 = { class: "h-5 flex items-center" };
const _hoisted_34 = ["checked", "disabled"];
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "amendmentType",
        class: "font-medium text-gray-700"
    }, "Job Level Change")
], -1));
const _hoisted_36 = { class: "flex items-start" };
const _hoisted_37 = { class: "h-5 flex items-center" };
const _hoisted_38 = ["checked", "disabled"];
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "amendmentType",
        class: "font-medium text-gray-700"
    }, "Line Manager Change")
], -1));
const _hoisted_40 = { class: "flex items-start" };
const _hoisted_41 = { class: "h-5 flex items-center" };
const _hoisted_42 = ["checked", "disabled"];
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "amendmentType",
        class: "font-medium text-gray-700"
    }, "Location Change")
], -1));
const _hoisted_44 = { class: "flex items-start" };
const _hoisted_45 = { class: "h-5 flex items-center" };
const _hoisted_46 = ["checked", "disabled"];
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "benifits-change-no",
        class: "font-medium text-gray-700"
    }, "Role & Benefits Change")
], -1));
const _hoisted_48 = { class: "flex items-start" };
const _hoisted_49 = { class: "h-5 flex items-center" };
const _hoisted_50 = ["checked", "disabled"];
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "amendmentType",
        class: "font-medium text-gray-700"
    }, "Salary/Hourly Rate Change")
], -1));
const _hoisted_52 = { class: "flex items-start" };
const _hoisted_53 = { class: "h-5 flex items-center" };
const _hoisted_54 = ["checked", "disabled"];
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "kronos-amendment",
        class: "font-medium text-gray-700"
    }, "Kronos")
], -1));
const _hoisted_56 = { class: "flex items-start" };
const _hoisted_57 = { class: "h-5 flex items-center" };
const _hoisted_58 = ["checked", "disabled"];
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "ad-hoc-amendment",
        class: "font-medium text-gray-700"
    }, "Type of IT account")
], -1));
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "text-sm text-red-500" }, [
    /*#__PURE__*/ _createElementVNode("p", null, "\n            Please remember to request any new IT Access as required via Ivanti.\n            If new or different SAP Access is required (i.e. if the employee is\n            now responsible to see new or different areas for the SAP structure)\n            please request this via Ivanti. It is equally as important to remove\n            areas no longer required for data protection reasons.\n          ")
], -1));
const _hoisted_61 = {
    key: 0,
    class: "col-span-6 mt-4"
};
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg my-4" }, "Job Level Change", -1));
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "newContractType",
    class: "block text-sm font-medium text-gray-70"
}, "New Contract: *", -1));
const _hoisted_64 = ["value", "disabled"];
const _hoisted_65 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "newJobLevel",
    class: "block text-sm font-medium text-gray-700 mt-4"
}, "New job level: *", -1));
const _hoisted_67 = ["value", "disabled"];
const _hoisted_68 = {
    key: 1,
    class: "text-red-500"
};
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "bonusType",
    class: "block text-sm font-medium text-gray-700 mt-4"
}, "Please confirm the bonus type *", -1));
const _hoisted_70 = ["value", "disabled"];
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "" }, null, -1));
const _hoisted_72 = ["value"];
const _hoisted_73 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_74 = { key: 1 };
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg my-4" }, "Entity / Cost Centre Change", -1));
const _hoisted_76 = { class: "col-span-6" };
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "entity",
    class: "block text-sm font-medium text-gray-700"
}, "New Entity: *", -1));
const _hoisted_78 = ["value", "disabled"];
const _hoisted_79 = ["value"];
const _hoisted_80 = ["value"];
const _hoisted_81 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_82 = {
    key: 0,
    class: "col-span-6 mt-4"
};
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "costCenter",
    class: "block text-sm font-medium text-gray-700"
}, "Cost Centre: *", -1));
const _hoisted_84 = ["value", "disabled"];
const _hoisted_85 = ["value"];
const _hoisted_86 = ["value"];
const _hoisted_87 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_88 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_89 = { class: "col-span-6" };
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "agreesEntityChange",
    class: "block text-sm font-medium text-gray-70"
}, "Has the employee been consulted and agrees to the entity change\n                and potentially their pay date (completed by 2nd line approver)\n                *", -1));
const _hoisted_91 = ["value"];
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "yes" }, "Yes", -1));
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "no" }, "No", -1));
const _hoisted_94 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_95 = { key: 2 };
const _hoisted_96 = {
    key: 0,
    class: "col-span-6 mt-4"
};
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "contract",
    class: "block text-sm font-medium text-gray-700"
}, "Contract change: *", -1));
const _hoisted_98 = ["value", "disabled"];
const _hoisted_99 = { class: "col-span-6 mt-4" };
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "contractType",
    class: "block text-sm font-medium text-gray-700"
}, "Contract type: *", -1));
const _hoisted_101 = ["value"];
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "permanent" }, "Permanent", -1));
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "fixed-term" }, "Fixed term", -1));
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "zero-hour" }, "Zero hour", -1));
const _hoisted_105 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_106 = {
    key: 1,
    class: "col-span-6 mt-4"
};
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, "Fixed term end date: *", -1));
const _hoisted_108 = ["value"];
const _hoisted_109 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_110 = { class: "grid grid-cols-3 gap-6" };
const _hoisted_111 = { class: "col-span-6 mt-4" };
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "businesscontact",
    class: "block text-sm font-medium text-gray-700"
}, "What is the name of the Business Contract that this role will\n                be working on? *", -1));
const _hoisted_113 = ["value"];
const _hoisted_114 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_115 = { key: 3 };
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg my-4" }, "Salary/Hourly Rate Change", -1));
const _hoisted_117 = { class: "col-span-6 mt-4" };
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "salaryChange",
    class: "block text-sm font-medium text-gray-700"
}, "Type of salary/hourly rate change: *", -1));
const _hoisted_119 = ["value", "disabled"];
const _hoisted_120 = ["value"];
const _hoisted_121 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_122 = { class: "col-span-6 mt-4" };
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "currency",
    class: "block text-sm font-medium text-gray-700"
}, "Currency of salary: *", -1));
const _hoisted_124 = ["value", "disabled"];
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    selected: "",
    value: "GBP"
}, "GBP", -1));
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "EUR" }, "EUR", -1));
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "USD" }, "USD", -1));
const _hoisted_128 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_129 = { class: "col-span-6 mt-4" };
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "currentSalary",
    class: "block text-sm font-medium text-gray-700"
}, "Current salary/hourly rate: *", -1));
const _hoisted_131 = ["value", "disabled"];
const _hoisted_132 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_133 = { class: "col-span-6 mt-4" };
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "newSalary",
    class: "block text-sm font-medium text-gray-700"
}, "New salary/hourly rate: *", -1));
const _hoisted_135 = ["value", "disabled"];
const _hoisted_136 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_137 = {
    key: 0,
    class: "col-span-6 mt-4"
};
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "diff",
    class: "block text-sm font-medium text-gray-700"
}, "Difference: *", -1));
const _hoisted_139 = ["value"];
const _hoisted_140 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_141 = { key: 4 };
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg my-4" }, "Kronos", -1));
const _hoisted_143 = { class: "col-span-6 mt-4" };
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h4", { class: "text-base font-medium text-gray-900 mb-4" }, "\n              If Kronos Time and Attendance is in operation for your area, what\n              action would you like to take for your employee?\n            ", -1));
const _hoisted_145 = { class: "space-y-3" };
const _hoisted_146 = { class: "flex items-center" };
const _hoisted_147 = ["checked", "disabled"];
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "kronos-action-add",
    class: "ml-3 text-sm font-medium text-gray-700"
}, "Add", -1));
const _hoisted_149 = { class: "flex items-center" };
const _hoisted_150 = ["checked", "disabled"];
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "kronos-action-amend",
    class: "ml-3 text-sm font-medium text-gray-700"
}, "Amend", -1));
const _hoisted_152 = { class: "flex items-center" };
const _hoisted_153 = ["checked", "disabled"];
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "kronos-action-remove",
    class: "ml-3 text-sm font-medium text-gray-700"
}, "Remove", -1));
const _hoisted_155 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_156 = { class: "col-span-6 mt-4" };
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "kronosCode",
    class: "block text-sm font-medium text-gray-700"
}, "Kronos Code: *", -1));
const _hoisted_158 = ["value", "disabled"];
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "" }, "-- Select --", -1));
const _hoisted_160 = ["value"];
const _hoisted_161 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_162 = { class: "col-span-6 mt-4" };
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "kronosLicense",
    class: "block text-sm font-medium text-gray-700"
}, "Kronos License: *", -1));
const _hoisted_164 = ["value", "disabled"];
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "" }, "-- Select --", -1));
const _hoisted_166 = ["value"];
const _hoisted_167 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_168 = { class: "col-span-6 mt-4" };
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "kronosRegionId",
    class: "block text-sm font-medium text-gray-700"
}, "Region ID: *", -1));
const _hoisted_170 = ["value", "disabled"];
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "" }, "-- Select --", -1));
const _hoisted_172 = ["value"];
const _hoisted_173 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_174 = { class: "col-span-6 mt-4" };
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "kronosContractId",
    class: "block text-sm font-medium text-gray-700"
}, "Contract ID: *", -1));
const _hoisted_176 = ["value", "disabled"];
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "" }, "-- Select --", -1));
const _hoisted_178 = ["value"];
const _hoisted_179 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_180 = { class: "col-span-6 mt-4" };
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "kronosTeamId",
    class: "block text-sm font-medium text-gray-700"
}, "Team ID: *", -1));
const _hoisted_182 = ["value", "disabled"];
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "" }, "-- Select --", -1));
const _hoisted_184 = ["value"];
const _hoisted_185 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_186 = { class: "col-span-6 mt-4" };
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "fteWeeklyHours",
    class: "block text-sm font-medium text-gray-700"
}, "FTE Weekly Hours: *", -1));
const _hoisted_188 = ["value", "disabled"];
const _hoisted_189 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_190 = { key: 5 };
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg my-4" }, "Allowance Change", -1));
const _hoisted_192 = { class: "col-span-6 w-full mx-1" };
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "salary_change",
    class: "block text-sm font-medium text-gray-700"
}, "Type of allowance change", -1));
const _hoisted_194 = ["id", "name", "value", "disabled"];
const _hoisted_195 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Amendment" }, "Amendment", -1));
const _hoisted_196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Addition" }, "Addition", -1));
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Removal" }, "Removal", -1));
const _hoisted_198 = {
    key: 0,
    class: ""
};
const _hoisted_199 = { class: "" };
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "allowanceExpire",
    class: "block text-sm font-medium text-gray-700 mt-2"
}, "Is this a permanent allowance change?", -1));
const _hoisted_201 = ["for"];
const _hoisted_202 = ["id", "checked", "name"];
const _hoisted_203 = ["for"];
const _hoisted_204 = ["id", "checked", "name"];
const _hoisted_205 = { class: "col-span-6 w-full mx-1" };
const _hoisted_206 = ["for"];
const _hoisted_207 = ["id", "value", "disabled", "name"];
const _hoisted_208 = {
    key: 0,
    class: "mt-2"
};
const _hoisted_209 = ["for"];
const _hoisted_210 = ["disabled", "name", "value"];
const _hoisted_211 = { class: "col-span-6 w-full mx-1" };
const _hoisted_212 = ["for"];
const _hoisted_213 = ["id", "value", "disabled", "name"];
const _hoisted_214 = { class: "col-span-6 mt-4" };
const _hoisted_215 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "roleChange",
    class: "block text-sm font-medium text-gray-700"
}, "Will the overtime rates that are applicable to the role change?\n              *", -1));
const _hoisted_216 = ["value", "disabled"];
const _hoisted_217 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_218 = { key: 6 };
const _hoisted_219 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg my-4" }, "Line Manager Change", -1));
const _hoisted_220 = { class: "col-span-6 mt-4" };
const _hoisted_221 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "lineManager",
    class: "block text-sm font-medium text-gray-700"
}, "New Line Manager: *", -1));
const _hoisted_222 = ["value", "disabled"];
const _hoisted_223 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_224 = { class: "col-span-6 mt-4" };
const _hoisted_225 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "employeeNumber",
    class: "block text-sm font-medium text-gray-700"
}, "New line manager employee number: *", -1));
const _hoisted_226 = ["value", "disabled"];
const _hoisted_227 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_228 = { class: "col-span-6 mt-4" };
const _hoisted_229 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "orgName",
    class: "block text-sm font-medium text-gray-700"
}, "SAP organisation name: *", -1));
const _hoisted_230 = ["value", "disabled"];
const _hoisted_231 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_232 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "text-sm text-red-500 pt-3" }, [
    /*#__PURE__*/ _createElementVNode("p", null, "\n              If the individual is already a line manager, the employee will be\n              assigned as reporting to them in SAP. If they are not currently a\n              line manager, a new organisation unit will be created using the\n              name you provide in the 'SAP organisation name' field above.\n            ")
], -1));
const _hoisted_233 = { key: 7 };
const _hoisted_234 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg my-4" }, "Location Change", -1));
const _hoisted_235 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_236 = { class: "col-span-6" };
const _hoisted_237 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "roleLocationSite",
    class: "block text-sm font-medium text-gray-700"
}, "New Role Location (Site): *", -1));
const _hoisted_238 = ["value", "disabled"];
const _hoisted_239 = ["value"];
const _hoisted_240 = ["value"];
const _hoisted_241 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_242 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_243 = { class: "col-span-6" };
const _hoisted_244 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "roleLocationPostcode",
    class: "block text-sm font-medium text-gray-700"
}, "New Location (Postcode):", -1));
const _hoisted_245 = ["value"];
const _hoisted_246 = { class: "col-span-6 w-full mt-4" };
const _hoisted_247 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "dwpSite",
    class: "block text-sm font-medium text-gray-700"
}, "Is this a DWP site? *", -1));
const _hoisted_248 = ["value", "disabled"];
const _hoisted_249 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Yes" }, "Yes", -1));
const _hoisted_250 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "No" }, "No", -1));
const _hoisted_251 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_252 = { class: "col-span-6 w-full mt-4" };
const _hoisted_253 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "hybridWorker",
    class: "block text-sm font-medium text-gray-700"
}, "Will the employee be a Hybrid Worker, i.e. has their working\n              status changed? *", -1));
const _hoisted_254 = ["value", "disabled"];
const _hoisted_255 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Yes" }, "Yes", -1));
const _hoisted_256 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "No" }, "No", -1));
const _hoisted_257 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_258 = { key: 8 };
const _hoisted_259 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg my-4" }, "Business Structure Change", -1));
const _hoisted_260 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "moreDetails",
    class: "block text-sm font-medium text-gray-700"
}, "Please note any additional details relating to a change in cost\n            code/centre or internal order number:\n          ", -1));
const _hoisted_261 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_262 = ["value"];
const _hoisted_263 = { class: "col-span-6 mt-4" };
const _hoisted_264 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "employeeSeconding",
    class: "block text-sm font-medium text-gray-700"
}, "Is the employee seconding (temporarily transferring) from/to\n              another EQUANS entity?: *", -1));
const _hoisted_265 = ["value", "disabled"];
const _hoisted_266 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Yes" }, "Yes", -1));
const _hoisted_267 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "No" }, "No", -1));
const _hoisted_268 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_269 = { key: 9 };
const _hoisted_270 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg my-4" }, "Hours/Work Pattern Change", -1));
const _hoisted_271 = { class: "col-span-6 mt-4" };
const _hoisted_272 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "currentSalary",
    class: "block text-sm font-medium text-gray-700"
}, "Current annual salary/hourly rate: *", -1));
const _hoisted_273 = ["value", "disabled"];
const _hoisted_274 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_275 = { class: "col-span-6 mt-4" };
const _hoisted_276 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "newSalary",
    class: "block text-sm font-medium text-gray-700"
}, "New annual salary/hourly rate: *", -1));
const _hoisted_277 = ["value", "disabled"];
const _hoisted_278 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_279 = { class: "mt-4" };
const _hoisted_280 = { class: "col-span-6 mt-4" };
const _hoisted_281 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "hoursPerWeek",
    class: "block text-sm font-medium text-gray-700"
}, "New hours per week", -1));
const _hoisted_282 = ["value", "disabled"];
const _hoisted_283 = { class: "col-span-6 mt-4" };
const _hoisted_284 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "fteHours",
    class: "block text-sm font-medium text-gray-700"
}, "FTE Hours - Record here the hours for a full time worker. If you\n              are unsure, please check with your local HR Rep *", -1));
const _hoisted_285 = ["value", "disabled"];
const _hoisted_286 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "" }, "-- Select --", -1));
const _hoisted_287 = ["value"];
const _hoisted_288 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_289 = { class: "col-span-6 mt-4" };
const _hoisted_290 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "weeksPerYear",
    class: "block text-sm font-medium text-gray-700"
}, "How many weeks will be worked per year?", -1));
const _hoisted_291 = ["value", "disabled"];
const _hoisted_292 = { key: 10 };
const _hoisted_293 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg my-4" }, "Role & Benefits Change", -1));
const _hoisted_294 = { class: "col-span-6 mt-4" };
const _hoisted_295 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "jobTitle",
    class: "block text-sm font-medium text-gray-700"
}, "New job title:", -1));
const _hoisted_296 = ["value", "disabled"];
const _hoisted_297 = { class: "mt-4" };
const _hoisted_298 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "secondment",
    class: "block text-sm font-medium text-gray-700"
}, "Is this a secondment? *", -1));
const _hoisted_299 = ["value", "disabled"];
const _hoisted_300 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Yes" }, "Yes", -1));
const _hoisted_301 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "No" }, "No", -1));
const _hoisted_302 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_303 = { key: 1 };
const _hoisted_304 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "secondmentAllowance",
    class: "block text-sm font-medium text-gray-700 mt-4 w-2/3"
}, [
    /*#__PURE__*/ _createTextVNode("Is the secondment to be paid as an Allowance (i.e. overtime\n                will "),
    /*#__PURE__*/ _createElementVNode("b", null, [
        /*#__PURE__*/ _createElementVNode("u", null, "not")
    ]),
    /*#__PURE__*/ _createTextVNode(" be paid at the seconded hourly rate) or\n                as an increase in Annual Salary (i.e. overtime\n                "),
    /*#__PURE__*/ _createElementVNode("b", null, [
        /*#__PURE__*/ _createElementVNode("u", null, "will")
    ]),
    /*#__PURE__*/ _createTextVNode(" be paid at the higher seconded hourly\n                rate")
], -1));
const _hoisted_305 = ["value", "disabled"];
const _hoisted_306 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Allowance" }, "Allowance", -1));
const _hoisted_307 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Salary" }, "Salary", -1));
const _hoisted_308 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_309 = {
    key: 1,
    class: "mt-4"
};
const _hoisted_310 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "allowanceAmount",
        class: "col-span-6 text-sm font-medium text-gray-700 mt-4 w-2/3"
    }, "Allowance amount:")
], -1));
const _hoisted_311 = { class: "flex" };
const _hoisted_312 = ["value"];
const _hoisted_313 = ["value", "disabled"];
const _hoisted_314 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", null, "GBP", -1));
const _hoisted_315 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", null, "USD", -1));
const _hoisted_316 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", null, "EUR", -1));
const _hoisted_317 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_318 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_319 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "secondmentEndDate",
    class: "block text-sm font-medium text-gray-700 mt-4"
}, "Secondment end date: *", -1));
const _hoisted_320 = ["value", "disabled"];
const _hoisted_321 = {
    key: 2,
    class: "text-red-500"
};
const _hoisted_322 = { class: "mt-4" };
const _hoisted_323 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "promotion",
    class: "block text-sm font-medium text-gray-700"
}, "Is this a promotion? *", -1));
const _hoisted_324 = ["value", "disabled"];
const _hoisted_325 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Yes" }, "Yes", -1));
const _hoisted_326 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "No" }, "No", -1));
const _hoisted_327 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_328 = {
    key: 0,
    class: "mt-4"
};
const _hoisted_329 = { class: "col-span-6 mt-4" };
const _hoisted_330 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "accountType",
    class: "block text-sm font-medium text-gray-700"
}, "Please confirm the type of account needed for the employee?:\n                *", -1));
const _hoisted_331 = ["value", "disabled"];
const _hoisted_332 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Laptop" }, "\n                  The employee will be given a company laptop/PC/PDA or smart\n                  phone\n                ", -1));
const _hoisted_333 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "No Laptop" }, "\n                  The employee will not be given any company IT equipment or\n                  Microsoft Office account\n                ", -1));
const _hoisted_334 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_335 = { class: "mt-4" };
const _hoisted_336 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "\n              Will the employee retain their existing T&C?\n            ", -1));
const _hoisted_337 = { class: "mt-4 space-y-4" };
const _hoisted_338 = { class: "h-5 flex items-center" };
const _hoisted_339 = ["id", "value", "checked", "disabled"];
const _hoisted_340 = { class: "ml-3 text-sm" };
const _hoisted_341 = {
    for: "retainTC",
    class: "font-medium text-gray-700"
};
const _hoisted_342 = { class: "mt-4" };
const _hoisted_343 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "\n              Will the employee move to EQUANS T&C?\n            ", -1));
const _hoisted_344 = { class: "mt-4 space-y-4" };
const _hoisted_345 = { class: "h-5 flex items-center" };
const _hoisted_346 = ["id", "value", "checked", "disabled"];
const _hoisted_347 = { class: "ml-3 text-sm" };
const _hoisted_348 = {
    for: "moveTC",
    class: "font-medium text-gray-700"
};
const _hoisted_349 = { class: "mt-4" };
const _hoisted_350 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "benifitsAdd",
    class: "block text-sm font-medium text-gray-700"
}, "Please detail any benefits you wish to add:", -1));
const _hoisted_351 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_352 = ["value"];
const _hoisted_353 = { class: "mt-4" };
const _hoisted_354 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "benifitsRemove",
    class: "block text-sm font-medium text-gray-700"
}, "Please detail any benefits you wish to remove:", -1));
const _hoisted_355 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_356 = ["value"];
const _hoisted_357 = { class: "mt-4" };
const _hoisted_358 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "healthAndSafetyChange",
    class: "block text-sm font-medium text-gray-700"
}, "Will the health & safety aspects of the role change? *", -1));
const _hoisted_359 = ["value", "disabled"];
const _hoisted_360 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Yes" }, "Yes", -1));
const _hoisted_361 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "No" }, "No", -1));
const _hoisted_362 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_363 = { class: "mt-4" };
const _hoisted_364 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "\n              Please select if any of the following are now required due to the\n              role change?\n            ", -1));
const _hoisted_365 = { class: "mt-4 space-y-4" };
const _hoisted_366 = { class: "h-5 flex items-center" };
const _hoisted_367 = ["id", "value", "checked", "disabled"];
const _hoisted_368 = { class: "ml-3 text-sm" };
const _hoisted_369 = {
    for: "roleUpdate",
    class: "font-medium text-gray-700"
};
const _hoisted_370 = { class: "mt-4" };
const _hoisted_371 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "\n              Will the appraisal method change?\n            ", -1));
const _hoisted_372 = { class: "mt-4 space-y-4" };
const _hoisted_373 = { class: "flex items-start" };
const _hoisted_374 = { class: "h-5 flex items-center" };
const _hoisted_375 = ["checked", "disabled"];
const _hoisted_376 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "confirmation",
        class: "font-medium text-gray-700"
    }, "I confirm that the employee is in Job Level 5-7 and that\n                      they should be included in the OneHR system (online\n                      appraisal process).")
], -1));
const _hoisted_377 = {
    key: 11,
    class: "mt-4"
};
const _hoisted_378 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "overtimeRates",
    class: "block text-sm font-medium text-gray-700"
}, "Will the overtime rates that are applicable to the role change?\n              *", -1));
const _hoisted_379 = ["value", "disabled"];
const _hoisted_380 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "" }, null, -1));
const _hoisted_381 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Yes" }, "Yes", -1));
const _hoisted_382 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "No" }, "No", -1));
const _hoisted_383 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_384 = {
    key: 0,
    class: "mt-4"
};
const _hoisted_385 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "overtimeRatesInfo",
    class: "block text-sm font-medium text-gray-700"
}, "Please provide overtime rates and when they will apply (e.g. if a\n              specific rate is only applicable at weekends). Also use this space\n              for any specific payments due that are not captured in the\n              Additional Allowances section below. *", -1));
const _hoisted_386 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_387 = ["value", "disabled"];
const _hoisted_388 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_389 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-red-500 text-bold" }, "\n              * Overtime must be stated within this box. 'Standard' should not\n              be noted. This can delay the processing of the contract.\n            ", -1));
const _hoisted_390 = {
    key: 12,
    class: "mt-8"
};
const _hoisted_391 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg my-4" }, "Direct Reports", -1));
const _hoisted_392 = { class: "col-span-6 mt-4" };
const _hoisted_393 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "peopleReporting",
    class: "block text-sm font-medium text-gray-700"
}, "Did the employee have people reporting into them? *", -1));
const _hoisted_394 = ["value", "disabled"];
const _hoisted_395 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Yes" }, "Yes", -1));
const _hoisted_396 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "No" }, "No", -1));
const _hoisted_397 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_398 = { class: "col-span-6 mt-4" };
const _hoisted_399 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "reportingToNow",
    class: "block text-sm font-medium text-gray-700"
}, "Will the employee now have people reporting into them? *", -1));
const _hoisted_400 = ["value", "disabled"];
const _hoisted_401 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Yes" }, "Yes", -1));
const _hoisted_402 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "No" }, "No", -1));
const _hoisted_403 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_404 = {
    key: 0,
    class: "mt-4"
};
const _hoisted_405 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "directReports",
    class: "block text-sm font-medium text-gray-700"
}, "Please detail any direct reports:", -1));
const _hoisted_406 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_407 = ["value"];
const _hoisted_408 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_409 = { key: 13 };
const _hoisted_410 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg my-4" }, "Type of IT account", -1));
const _hoisted_411 = { class: "col-span-6 mt-4" };
const _hoisted_412 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "adHocAccountType",
    class: "block text-sm font-medium text-gray-700"
}, "Please confirm the type of account needed for the employee?:", -1));
const _hoisted_413 = ["value", "disabled"];
const _hoisted_414 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "" }, null, -1));
const _hoisted_415 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Laptop" }, "\n                The employee will be given a company laptop/PC/PDA or smart\n                phone\n              ", -1));
const _hoisted_416 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "No Laptop" }, "\n                The employee will not be given any company IT equipment or\n                Microsoft Office account\n              ", -1));
const _hoisted_417 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_418 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_WorkingWeek = _resolveComponent("WorkingWeek");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createTextVNode(),
                    _createElementVNode("input", {
                        id: "effectiveDate-input",
                        value: _ctx.formData.effectiveDate,
                        disabled: _ctx.disableForm,
                        type: "date",
                        name: "effectiveDate",
                        autocomplete: "name",
                        class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200", {
                                'error-border': _ctx.v$.formData.effectiveDate.$error,
                                'border-red-500': _ctx.v$.formData.effectiveDate.$error,
                            }]),
                        onInput: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                        onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.v$.formData.effectiveDate.$touch()))
                    }, null, 42, _hoisted_6),
                    _createTextVNode(),
                    (_ctx.v$.formData.effectiveDate.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, "\n            * " + _toDisplayString(_ctx.v$.formData.effectiveDate.$errors[0].$message), 1))
                        : _createCommentVNode("", true)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("fieldset", null, [
                        _hoisted_9,
                        _createTextVNode(),
                        (_ctx.v$.formData.amendmentType.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "\n              * " + _toDisplayString(_ctx.v$.formData.amendmentType.$errors[0].$message), 1))
                            : _createCommentVNode("", true),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, [
                                        _createElementVNode("input", {
                                            id: "allowance-change-yes",
                                            value: "Allowance Change",
                                            name: "amendmentType",
                                            type: "checkbox",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed",
                                            checked: _ctx.formData.amendmentType?.includes('Allowance Change'),
                                            disabled: _ctx.disableForm,
                                            onChange: _cache[2] || (_cache[2] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args))),
                                            onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.v$.formData.amendmentType.$touch()))
                                        }, null, 40, _hoisted_14)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_15
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("div", _hoisted_17, [
                                        _createElementVNode("input", {
                                            id: "business_structure-no",
                                            value: "Business Structure Change",
                                            name: "amendmentType",
                                            type: "checkbox",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed",
                                            checked: _ctx.formData.amendmentType?.includes('Business Structure Change'),
                                            disabled: _ctx.disableForm,
                                            onChange: _cache[4] || (_cache[4] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args))),
                                            onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.v$.formData.amendmentType.$touch()))
                                        }, null, 40, _hoisted_18)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_19
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("div", _hoisted_21, [
                                        _createElementVNode("input", {
                                            id: "contract-change-no",
                                            value: "Contract change",
                                            name: "amendmentType",
                                            type: "checkbox",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed",
                                            checked: _ctx.formData.amendmentType?.includes('Contract change'),
                                            disabled: _ctx.disableForm,
                                            onChange: _cache[6] || (_cache[6] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args))),
                                            onBlur: _cache[7] || (_cache[7] = ($event) => (_ctx.v$.formData.amendmentType.$touch()))
                                        }, null, 40, _hoisted_22)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_23
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("div", _hoisted_25, [
                                        _createElementVNode("input", {
                                            id: "entity-change-no",
                                            value: "Entity Change",
                                            name: "amendmentType",
                                            type: "checkbox",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed",
                                            checked: _ctx.formData.amendmentType?.includes('Entity Change'),
                                            disabled: _ctx.disableForm,
                                            onChange: _cache[8] || (_cache[8] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args))),
                                            onBlur: _cache[9] || (_cache[9] = ($event) => (_ctx.v$.formData.amendmentType.$touch()))
                                        }, null, 40, _hoisted_26)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_27
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("div", _hoisted_29, [
                                        _createElementVNode("input", {
                                            id: "pattern-change-no",
                                            value: "Hours/Work Pattern Change",
                                            name: "amendmentType",
                                            type: "checkbox",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed",
                                            checked: _ctx.formData.amendmentType?.includes('Hours/Work Pattern Change'),
                                            disabled: _ctx.disableForm,
                                            onChange: _cache[10] || (_cache[10] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args)))
                                        }, null, 40, _hoisted_30)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_31
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_32, [
                                    _createElementVNode("div", _hoisted_33, [
                                        _createElementVNode("input", {
                                            id: "level-change-no",
                                            value: "Job Level Change",
                                            name: "amendmentType",
                                            type: "checkbox",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed",
                                            checked: _ctx.formData.amendmentType?.includes('Job Level Change'),
                                            disabled: _ctx.disableForm,
                                            onChange: _cache[11] || (_cache[11] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args))),
                                            onBlur: _cache[12] || (_cache[12] = ($event) => (_ctx.v$.formData.amendmentType.$touch()))
                                        }, null, 40, _hoisted_34)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_35
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("div", _hoisted_37, [
                                        _createElementVNode("input", {
                                            id: "manager-change-no",
                                            value: "Line Manager Change",
                                            name: "amendmentType",
                                            type: "checkbox",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed",
                                            checked: _ctx.formData.amendmentType?.includes('Line Manager Change'),
                                            disabled: _ctx.disableForm,
                                            onChange: _cache[13] || (_cache[13] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args))),
                                            onBlur: _cache[14] || (_cache[14] = ($event) => (_ctx.v$.formData.amendmentType.$touch()))
                                        }, null, 40, _hoisted_38)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_39
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_40, [
                                    _createElementVNode("div", _hoisted_41, [
                                        _createElementVNode("input", {
                                            id: "location-change-no",
                                            value: "Location Change",
                                            name: "amendmentType",
                                            type: "checkbox",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed",
                                            checked: _ctx.formData.amendmentType?.includes('Location Change'),
                                            disabled: _ctx.disableForm,
                                            onChange: _cache[15] || (_cache[15] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args))),
                                            onBlur: _cache[16] || (_cache[16] = ($event) => (_ctx.v$.formData.amendmentType.$touch()))
                                        }, null, 40, _hoisted_42)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_43
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_44, [
                                    _createElementVNode("div", _hoisted_45, [
                                        _createElementVNode("input", {
                                            id: "benifits-change-no",
                                            value: "Role & Benefits Change",
                                            name: "amendmentType",
                                            type: "checkbox",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed",
                                            checked: _ctx.formData.amendmentType?.includes('Role & Benefits Change'),
                                            disabled: _ctx.disableForm,
                                            onChange: _cache[17] || (_cache[17] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args))),
                                            onBlur: _cache[18] || (_cache[18] = ($event) => (_ctx.v$.formData.amendmentType.$touch()))
                                        }, null, 40, _hoisted_46)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_47
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_48, [
                                    _createElementVNode("div", _hoisted_49, [
                                        _createElementVNode("input", {
                                            id: "salary-change-no",
                                            value: "Salary/Hourly Rate Change",
                                            name: "amendmentType",
                                            type: "checkbox",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed",
                                            checked: _ctx.formData.amendmentType?.includes('Salary/Hourly Rate Change'),
                                            disabled: _ctx.disableForm,
                                            onChange: _cache[19] || (_cache[19] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args))),
                                            onBlur: _cache[20] || (_cache[20] = ($event) => (_ctx.v$.formData.amendmentType.$touch()))
                                        }, null, 40, _hoisted_50)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_51
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_52, [
                                    _createElementVNode("div", _hoisted_53, [
                                        _createElementVNode("input", {
                                            id: "kronos-amendment",
                                            value: "Kronos",
                                            name: "amendmentType",
                                            type: "checkbox",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed",
                                            checked: _ctx.formData.amendmentType?.includes('Kronos'),
                                            disabled: _ctx.disableForm,
                                            onChange: _cache[21] || (_cache[21] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args))),
                                            onBlur: _cache[22] || (_cache[22] = ($event) => (_ctx.v$.formData.amendmentType.$touch()))
                                        }, null, 40, _hoisted_54)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_55
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_56, [
                                    _createElementVNode("div", _hoisted_57, [
                                        _createElementVNode("input", {
                                            id: "ad-hoc-amendment",
                                            value: "Ad-Hoc",
                                            name: "amendmentType",
                                            type: "checkbox",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed",
                                            checked: _ctx.formData.amendmentType?.includes('Ad-Hoc'),
                                            disabled: _ctx.disableForm,
                                            onChange: _cache[23] || (_cache[23] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args))),
                                            onBlur: _cache[24] || (_cache[24] = ($event) => (_ctx.v$.formData.amendmentType.$touch()))
                                        }, null, 40, _hoisted_58)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_59
                                ])
                            ])
                        ])
                    ])
                ]),
                _createTextVNode(),
                _hoisted_60,
                _createTextVNode(),
                (_ctx.formData?.amendmentType?.includes('Job Level Change'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                        _hoisted_62,
                        _createTextVNode(),
                        _hoisted_63,
                        _createTextVNode(),
                        _createElementVNode("select", {
                            id: "select-contract-type",
                            value: _ctx.formData?.newContractType,
                            name: "newContractType",
                            class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:text-gray-600 disabled:cursor-not-allowed",
                            disabled: _ctx.disableForm,
                            onChange: _cache[25] || (_cache[25] =
                                //@ts-ignore
                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                            onBlur: _cache[26] || (_cache[26] = ($event) => (_ctx.v$.formData.newContractType
                                ? _ctx.v$.formData.newContractType.$touch()
                                : null))
                        }, [
                            (_ctx.disableForm)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.configItems.CONTRACTS, (contract) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: contract.ContractType
                                    }, _toDisplayString(contract.ContractType), 1));
                                }), 128))
                                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.activeContractTypes, (contract) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: contract.ContractType
                                    }, _toDisplayString(contract.ContractType), 1));
                                }), 128))
                        ], 40, _hoisted_64),
                        _createTextVNode(),
                        (_ctx.v$.formData.newContractType?.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_65, "\n            * " + _toDisplayString(_ctx.v$.formData.newContractType?.$errors[0]?.$message), 1))
                            : _createCommentVNode("", true),
                        _createTextVNode(),
                        _hoisted_66,
                        _createTextVNode(),
                        _createElementVNode("select", {
                            id: "newJobLevel",
                            value: _ctx.formData?.newJobLevel,
                            name: "newJobLevel",
                            class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                            disabled: _ctx.disableForm,
                            onChange: _cache[27] || (_cache[27] =
                                //@ts-ignore
                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                            onBlur: _cache[28] || (_cache[28] = ($event) => (_ctx.v$.formData.newJobLevel.$touch()))
                        }, [
                            (_ctx.disableForm)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.currentContractType?.Items, (contract) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: contract.ID
                                    }, _toDisplayString(contract.ContractName), 1));
                                }), 128))
                                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.activeJobLevels, (contract) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: contract.ID
                                    }, _toDisplayString(contract.ContractName), 1));
                                }), 128))
                        ], 40, _hoisted_67),
                        _createTextVNode(),
                        (_ctx.v$.formData.newJobLevel.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_68, "\n            * " + _toDisplayString(_ctx.v$.formData.newJobLevel.$errors[0].$message), 1))
                            : _createCommentVNode("", true),
                        _createTextVNode(),
                        (_ctx.showBonusType)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _hoisted_69,
                                _createTextVNode(),
                                _createElementVNode("select", {
                                    id: "bonusType",
                                    value: _ctx.formData?.bonusType,
                                    name: "bonusType",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                    disabled: _ctx.disableForm,
                                    onChange: _cache[29] || (_cache[29] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[30] || (_cache[30] = ($event) => (_ctx.v$.formData.bonusType.$touch()))
                                }, [
                                    _hoisted_71,
                                    _createTextVNode(),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bonusTypes, (bt) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: bt,
                                            value: bt
                                        }, _toDisplayString(bt), 9, _hoisted_72));
                                    }), 128))
                                ], 40, _hoisted_70),
                                _createTextVNode(),
                                (_ctx.v$.formData.bonusType.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_73, "\n              * " + _toDisplayString(_ctx.v$.formData.bonusType.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ], 64))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.formData?.amendmentType?.includes('Entity Change'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                        _hoisted_75,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_76, [
                            _hoisted_77,
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "entity_change",
                                name: "entity",
                                value: _ctx.formData.entity,
                                disabled: _ctx.disableForm,
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                onChange: _cache[31] || (_cache[31] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[32] || (_cache[32] = ($event) => (_ctx.v$.formData.entity.$touch()))
                            }, [
                                (_ctx.disableForm)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.configItems.ENTITIES, (entity) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: entity.entity,
                                            value: entity.entity
                                        }, _toDisplayString(entity.entity), 9, _hoisted_79));
                                    }), 128))
                                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.activeEntities, (entity) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: entity.entity,
                                            value: entity.entity
                                        }, _toDisplayString(entity.entity), 9, _hoisted_80));
                                    }), 128))
                            ], 40, _hoisted_78),
                            _createTextVNode(),
                            (_ctx.v$.formData.entity.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_81, "\n              * " + _toDisplayString(_ctx.v$.formData.entity.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        (_ctx.formData.entity)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                _hoisted_83,
                                _createTextVNode(),
                                _createElementVNode("select", {
                                    id: "entity_change",
                                    name: "costCenter",
                                    value: _ctx.formData.costCenter,
                                    disabled: _ctx.disableForm,
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                    onChange: _cache[33] || (_cache[33] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[34] || (_cache[34] = ($event) => (_ctx.v$.formData.costCenter.$touch()))
                                }, [
                                    (_ctx.disableForm)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.currentEntity.Items, (cc) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: cc.ID,
                                                value: cc.CostCodeLookUp
                                            }, _toDisplayString(cc.CostCodeLookUp), 9, _hoisted_85));
                                        }), 128))
                                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.activeCCs, (cc) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: cc.ID,
                                                value: cc.CostCodeLookUp
                                            }, _toDisplayString(cc.CostCodeLookUp), 9, _hoisted_86));
                                        }), 128))
                                ], 40, _hoisted_84),
                                _createTextVNode(),
                                (_ctx.v$.formData.costCenter.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_87, "\n              * " + _toDisplayString(_ctx.v$.formData.costCenter.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_88, [
                            _createElementVNode("div", _hoisted_89, [
                                _hoisted_90,
                                _createTextVNode(),
                                _createElementVNode("select", {
                                    id: "agreesEntityChange",
                                    name: "agreesEntityChange",
                                    autocomplete: "agreesEntityChange",
                                    value: _ctx.formData.agreesEntityChange,
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                                    onChange: _cache[35] || (_cache[35] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[36] || (_cache[36] = ($event) => (_ctx.v$.formData.agreesEntityChange.$touch()))
                                }, [
                                    _hoisted_92,
                                    _createTextVNode(),
                                    _hoisted_93
                                ], 40, _hoisted_91),
                                _createTextVNode(),
                                (_ctx.v$.formData.agreesEntityChange.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_94, "\n                * " + _toDisplayString(_ctx.v$.formData.agreesEntityChange.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.formData?.amendmentType?.includes('Contract change'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                        (_ctx.formData.contractType)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                _hoisted_97,
                                _createTextVNode(),
                                _createElementVNode("select", {
                                    id: "contract",
                                    name: "contract",
                                    value: _ctx.formData.contract,
                                    disabled: _ctx.disableForm,
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                    onChange: _cache[37] || (_cache[37] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[38] || (_cache[38] = ($event) => (_ctx.v$.formData.contract.$touch()))
                                }, [
                                    (_ctx.disableForm)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.currentContract?.Items, (contract) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: contract.ID
                                            }, _toDisplayString(contract.Contract), 1));
                                        }), 128))
                                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.activeContracts, (contract) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: contract.ID
                                            }, _toDisplayString(contract.Contract), 1));
                                        }), 128))
                                ], 40, _hoisted_98)
                            ]))
                            : _createCommentVNode("", true),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_99, [
                            _hoisted_100,
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "contractTerm",
                                name: "contractTerm",
                                value: _ctx.formData.contractTerm,
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                onChange: _cache[39] || (_cache[39] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[40] || (_cache[40] = ($event) => (_ctx.v$.formData.contractTerm.$touch()))
                            }, [
                                _hoisted_102,
                                _createTextVNode(),
                                _hoisted_103,
                                _createTextVNode(),
                                _hoisted_104
                            ], 40, _hoisted_101),
                            _createTextVNode(),
                            (_ctx.v$.formData.contractTerm.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_105, "\n              * " + _toDisplayString(_ctx.v$.formData.contractTerm.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        (_ctx.formData.contractTerm === 'fixed-term')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                _hoisted_107,
                                _createTextVNode(),
                                _createElementVNode("div", null, [
                                    _createElementVNode("input", {
                                        id: "fixedTermEndDate-input",
                                        name: "fixedTermEndDate",
                                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                        type: "date",
                                        value: _ctx.formData.fixedTermEndDate,
                                        onChange: _cache[41] || (_cache[41] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                        onBlur: _cache[42] || (_cache[42] = ($event) => (_ctx.v$.formData.fixedTermEndDate.$touch()))
                                    }, null, 40, _hoisted_108),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.fixedTermEndDate.$error)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_109, "\n                * " + _toDisplayString(_ctx.v$.formData.fixedTermEndDate.$errors[0].$message), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_110, [
                            _createElementVNode("div", _hoisted_111, [
                                _hoisted_112,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    id: "businesscontact",
                                    type: "text",
                                    name: "businesscontact",
                                    value: _ctx.formData.businesscontact,
                                    autocomplete: "businesscontact",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                                    onInput: _cache[43] || (_cache[43] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[44] || (_cache[44] = ($event) => (_ctx.v$.formData.businesscontact.$touch()))
                                }, null, 40, _hoisted_113),
                                _createTextVNode(),
                                (_ctx.v$.formData.businesscontact.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_114, "\n                * " + _toDisplayString(_ctx.v$.formData.businesscontact.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.formData?.amendmentType?.includes('Salary/Hourly Rate Change'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                        _hoisted_116,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_117, [
                            _hoisted_118,
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "salaryChange",
                                name: "salaryChange",
                                value: _ctx.formData.salaryChange,
                                disabled: _ctx.disableForm,
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                onChange: _cache[45] || (_cache[45] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[46] || (_cache[46] = ($event) => (_ctx.v$.formData.salaryChange.$touch()))
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.changeTypes, (type) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: type,
                                        value: type
                                    }, _toDisplayString(type), 9, _hoisted_120));
                                }), 128))
                            ], 40, _hoisted_119),
                            _createTextVNode(),
                            (_ctx.v$.formData.salaryChange.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_121, "\n              * " + _toDisplayString(_ctx.v$.formData.salaryChange.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_122, [
                            _hoisted_123,
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "currency",
                                name: "currency",
                                value: _ctx.formData.currency,
                                disabled: _ctx.disableForm,
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                onChange: _cache[47] || (_cache[47] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[48] || (_cache[48] = ($event) => (_ctx.v$.formData.currency.$touch()))
                            }, [
                                _hoisted_125,
                                _createTextVNode(),
                                _hoisted_126,
                                _createTextVNode(),
                                _hoisted_127
                            ], 40, _hoisted_124),
                            _createTextVNode(),
                            (_ctx.v$.formData.currency.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_128, "\n                * " + _toDisplayString(_ctx.v$.formData.currency.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_129, [
                            _hoisted_130,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                id: "current_salary-name-input",
                                value: _ctx.formData.currentSalary,
                                disabled: _ctx.disableForm,
                                min: "0",
                                type: "number",
                                name: "currentSalary",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                onInput: _cache[49] || (_cache[49] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[50] || (_cache[50] = ($event) => (_ctx.v$.formData.currentSalary.$touch()))
                            }, null, 40, _hoisted_131),
                            _createTextVNode(),
                            (_ctx.v$.formData.currentSalary.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_132, "\n                * " + _toDisplayString(_ctx.v$.formData.currentSalary.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_133, [
                            _hoisted_134,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                id: "new_salary-name-input",
                                value: _ctx.formData.newSalary,
                                disabled: _ctx.disableForm,
                                min: "0",
                                type: "number",
                                name: "newSalary",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                onInput: _cache[51] || (_cache[51] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[52] || (_cache[52] = ($event) => (_ctx.v$.formData.newSalary.$touch()))
                            }, null, 40, _hoisted_135),
                            _createTextVNode(),
                            (_ctx.v$.formData.newSalary.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_136, "\n                * " + _toDisplayString(_ctx.v$.formData.newSalary.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        (_ctx.formData.diff)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                                _hoisted_138,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    id: "diff-name-input",
                                    value: `${_ctx.formData.diff}%`,
                                    type: "text",
                                    name: "diff",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                    disabled: "",
                                    onBlur: _cache[53] || (_cache[53] = ($event) => (_ctx.v$.formData.diff.$touch()))
                                }, null, 40, _hoisted_139),
                                _createTextVNode(),
                                (_ctx.v$.formData.diff.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_140, "\n                * " + _toDisplayString(_ctx.v$.formData.diff.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.formData?.amendmentType?.includes('Kronos'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                        _hoisted_142,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_143, [
                            _hoisted_144,
                            _createTextVNode(),
                            _createElementVNode("fieldset", null, [
                                _createElementVNode("div", _hoisted_145, [
                                    _createElementVNode("div", _hoisted_146, [
                                        _createElementVNode("input", {
                                            id: "kronos-action-add",
                                            name: "kronosAction",
                                            type: "radio",
                                            value: "Add",
                                            checked: _ctx.formData.kronosAction === 'Add',
                                            disabled: _ctx.disableForm,
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed",
                                            onChange: _cache[54] || (_cache[54] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                            onBlur: _cache[55] || (_cache[55] = ($event) => (_ctx.v$.formData.kronosAction.$touch()))
                                        }, null, 40, _hoisted_147),
                                        _createTextVNode(),
                                        _hoisted_148
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_149, [
                                        _createElementVNode("input", {
                                            id: "kronos-action-amend",
                                            name: "kronosAction",
                                            type: "radio",
                                            value: "Amend",
                                            checked: _ctx.formData.kronosAction === 'Amend',
                                            disabled: _ctx.disableForm,
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed",
                                            onChange: _cache[56] || (_cache[56] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                            onBlur: _cache[57] || (_cache[57] = ($event) => (_ctx.v$.formData.kronosAction.$touch()))
                                        }, null, 40, _hoisted_150),
                                        _createTextVNode(),
                                        _hoisted_151
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_152, [
                                        _createElementVNode("input", {
                                            id: "kronos-action-remove",
                                            name: "kronosAction",
                                            type: "radio",
                                            value: "Remove",
                                            checked: _ctx.formData.kronosAction === 'Remove',
                                            disabled: _ctx.disableForm,
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed",
                                            onChange: _cache[58] || (_cache[58] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                            onBlur: _cache[59] || (_cache[59] = ($event) => (_ctx.v$.formData.kronosAction.$touch()))
                                        }, null, 40, _hoisted_153),
                                        _createTextVNode(),
                                        _hoisted_154
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            (_ctx.v$.formData.kronosAction?.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_155, "\n              * " + _toDisplayString(_ctx.v$.formData.kronosAction?.$errors[0]?.$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        (_ctx.formData.kronosAction === 'Add' ||
                            _ctx.formData.kronosAction === 'Amend')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_156, [
                                    _hoisted_157,
                                    _createTextVNode(),
                                    _createElementVNode("select", {
                                        id: "kronosCode",
                                        name: "kronosCode",
                                        value: _ctx.formData.kronosCode,
                                        disabled: _ctx.disableForm,
                                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                        onChange: _cache[60] || (_cache[60] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                        onBlur: _cache[61] || (_cache[61] = ($event) => (_ctx.v$.formData.kronosCode?.$touch()))
                                    }, [
                                        _hoisted_159,
                                        _createTextVNode(),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kronosCodeOptions, (opt) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: opt.ID,
                                                value: opt.ID
                                            }, _toDisplayString(opt.ID), 9, _hoisted_160));
                                        }), 128))
                                    ], 40, _hoisted_158),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.kronosCode?.$error)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_161, "\n                * " + _toDisplayString(_ctx.v$.formData.kronosCode?.$errors[0]?.$message), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_162, [
                                    _hoisted_163,
                                    _createTextVNode(),
                                    _createElementVNode("select", {
                                        id: "kronosLicense",
                                        name: "kronosLicense",
                                        value: _ctx.formData.kronosLicense,
                                        disabled: _ctx.disableForm,
                                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                        onChange: _cache[62] || (_cache[62] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                        onBlur: _cache[63] || (_cache[63] = ($event) => (_ctx.v$.formData.kronosLicense?.$touch()))
                                    }, [
                                        _hoisted_165,
                                        _createTextVNode(),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kronosLicenseOptions, (opt) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: opt.ID,
                                                value: opt.ID
                                            }, _toDisplayString(opt.Label || opt.ID), 9, _hoisted_166));
                                        }), 128))
                                    ], 40, _hoisted_164),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.kronosLicense?.$error)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_167, "\n                * " + _toDisplayString(_ctx.v$.formData.kronosLicense?.$errors[0]?.$message), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_168, [
                                    _hoisted_169,
                                    _createTextVNode(),
                                    _createElementVNode("select", {
                                        id: "kronosRegionId",
                                        name: "kronosRegionId",
                                        value: _ctx.formData.kronosRegionId,
                                        disabled: _ctx.disableForm,
                                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                        onChange: _cache[64] || (_cache[64] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                        onBlur: _cache[65] || (_cache[65] = ($event) => (_ctx.v$.formData.kronosRegionId?.$touch()))
                                    }, [
                                        _hoisted_171,
                                        _createTextVNode(),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kronosRegionOptions, (region) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: region.ID,
                                                value: region.ID
                                            }, _toDisplayString(region.Label || region.ID), 9, _hoisted_172));
                                        }), 128))
                                    ], 40, _hoisted_170),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.kronosRegionId?.$error)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_173, "\n                * " + _toDisplayString(_ctx.v$.formData.kronosRegionId?.$errors[0]?.$message), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_174, [
                                    _hoisted_175,
                                    _createTextVNode(),
                                    _createElementVNode("select", {
                                        id: "kronosContractId",
                                        name: "kronosContractId",
                                        value: _ctx.formData.kronosContractId,
                                        disabled: _ctx.disableForm,
                                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                        onChange: _cache[66] || (_cache[66] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                        onBlur: _cache[67] || (_cache[67] = ($event) => (_ctx.v$.formData.kronosContractId?.$touch()))
                                    }, [
                                        _hoisted_177,
                                        _createTextVNode(),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kronosContractOptions, (contract) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: contract.ID,
                                                value: contract.ID
                                            }, _toDisplayString(contract.Label || contract.ID), 9, _hoisted_178));
                                        }), 128))
                                    ], 40, _hoisted_176),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.kronosContractId?.$error)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_179, "\n                * " + _toDisplayString(_ctx.v$.formData.kronosContractId?.$errors[0]?.$message), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_180, [
                                    _hoisted_181,
                                    _createTextVNode(),
                                    _createElementVNode("select", {
                                        id: "kronosTeamId",
                                        name: "kronosTeamId",
                                        value: _ctx.formData.kronosTeamId,
                                        disabled: _ctx.disableForm,
                                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                        onChange: _cache[68] || (_cache[68] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                        onBlur: _cache[69] || (_cache[69] = ($event) => (_ctx.v$.formData.kronosTeamId?.$touch()))
                                    }, [
                                        _hoisted_183,
                                        _createTextVNode(),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kronosTeamOptions, (team) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: team.ID,
                                                value: team.ID
                                            }, _toDisplayString(team.Label || team.ID), 9, _hoisted_184));
                                        }), 128))
                                    ], 40, _hoisted_182),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.kronosTeamId?.$error)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_185, "\n                * " + _toDisplayString(_ctx.v$.formData.kronosTeamId?.$errors[0]?.$message), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_186, [
                                    _hoisted_187,
                                    _createTextVNode(),
                                    _createElementVNode("input", {
                                        id: "fteWeeklyHours-input",
                                        value: _ctx.formData.fteWeeklyHours,
                                        disabled: _ctx.disableForm,
                                        type: "number",
                                        min: "0",
                                        max: "99.99",
                                        step: "0.01",
                                        name: "fteWeeklyHours",
                                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                        onInput: _cache[70] || (_cache[70] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                        onBlur: _cache[71] || (_cache[71] = ($event) => (_ctx.v$.formData.fteWeeklyHours?.$touch()))
                                    }, null, 40, _hoisted_188),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.fteWeeklyHours?.$error)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_189, "\n                * " + _toDisplayString(_ctx.v$.formData.fteWeeklyHours?.$errors[0]?.$message), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ], 64))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.formData?.amendmentType?.includes('Allowance Change'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_190, [
                        _hoisted_191,
                        _createTextVNode(),
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                            return _createElementVNode("div", {
                                key: n,
                                class: "flex justify-between mt-4"
                            }, [
                                _createElementVNode("div", _hoisted_192, [
                                    _hoisted_193,
                                    _createTextVNode(),
                                    _createElementVNode("select", {
                                        id: `typeChange${n}`,
                                        name: `typeChange${n}`,
                                        value: _ctx.formData[`typeChange${n}`],
                                        disabled: _ctx.disableForm,
                                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                        onChange: _cache[72] || (_cache[72] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                                    }, [
                                        _hoisted_195,
                                        _createTextVNode(),
                                        _hoisted_196,
                                        _createTextVNode(),
                                        _hoisted_197
                                    ], 40, _hoisted_194),
                                    _createTextVNode(),
                                    (_ctx.formData[`typeChange${n}`] === 'Amendment' ||
                                        _ctx.formData[`typeChange${n}`] === 'Addition')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_198, [
                                            _createElementVNode("div", _hoisted_199, [
                                                _hoisted_200,
                                                _createTextVNode(),
                                                _createElementVNode("label", {
                                                    for: `allowance-expire-yes${n}`,
                                                    class: "text-sm font-medium text-gray-700"
                                                }, "Yes", 8, _hoisted_201),
                                                _createTextVNode(),
                                                _createElementVNode("input", {
                                                    id: `allowance-expire-yes${n}`,
                                                    type: "radio",
                                                    value: "Yes",
                                                    checked: _ctx.formData[`allowanceExpire${n}`] === 'Yes',
                                                    name: `allowanceExpire${n}`,
                                                    class: "ml-2 focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed",
                                                    onChange: _cache[73] || (_cache[73] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args)))
                                                }, null, 40, _hoisted_202),
                                                _createTextVNode(),
                                                _createElementVNode("label", {
                                                    for: `allowance-expire-no${n}`,
                                                    class: "text-sm font-medium text-gray-700 pl-2"
                                                }, "No", 8, _hoisted_203),
                                                _createTextVNode(),
                                                _createElementVNode("input", {
                                                    id: `allowance-expire-no${n}`,
                                                    type: "radio",
                                                    value: "No",
                                                    checked: _ctx.formData[`allowanceExpire${n}`] === 'No',
                                                    name: `allowanceExpire${n}`,
                                                    class: "ml-2 focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed",
                                                    onChange: _cache[74] || (_cache[74] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args)))
                                                }, null, 40, _hoisted_204)
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_205, [
                                    _createElementVNode("label", {
                                        for: `newAllowanceType${n}`,
                                        class: "block text-sm font-medium text-gray-700"
                                    }, "New allowance type", 8, _hoisted_206),
                                    _createTextVNode(),
                                    _createElementVNode("input", {
                                        id: `new_allowance_type-name-input_${n}`,
                                        value: _ctx.formData[`newAllowanceType${n}`],
                                        disabled: _ctx.disableForm,
                                        type: "text",
                                        name: `newAllowanceType${n}`,
                                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                        onInput: _cache[75] || (_cache[75] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                                    }, null, 40, _hoisted_207),
                                    _createTextVNode(),
                                    (_ctx.formData[`allowanceExpire${n}`] === 'No')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_208, [
                                            _createElementVNode("label", {
                                                for: `allowanceEndDate${n}`,
                                                class: "text-sm font-medium text-gray-700"
                                            }, "Allowance end date:", 8, _hoisted_209),
                                            _createTextVNode(),
                                            _createElementVNode("input", {
                                                id: "allowanceEndDate-input",
                                                disabled: _ctx.disableForm,
                                                type: "date",
                                                name: `allowanceEndDate${n}`,
                                                autocomplete: "name",
                                                value: _ctx.formData[`allowanceEndDate${n}`],
                                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                                onInput: _cache[76] || (_cache[76] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                                            }, null, 40, _hoisted_210)
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_211, [
                                    _createElementVNode("label", {
                                        for: `perAnnum${n}`,
                                        class: "block text-sm font-medium text-gray-700"
                                    }, "New allowance per annum", 8, _hoisted_212),
                                    _createTextVNode(),
                                    _createElementVNode("input", {
                                        id: `per_annum-name-input_${n}`,
                                        value: _ctx.formData[`perAnnum${n}`],
                                        disabled: _ctx.disableForm,
                                        type: "text",
                                        name: `perAnnum${n}`,
                                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                        onInput: _cache[77] || (_cache[77] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                                    }, null, 40, _hoisted_213)
                                ])
                            ]);
                        }), 64)),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_214, [
                            _hoisted_215,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                id: "role_change-name-input",
                                value: _ctx.formData.roleChange,
                                disabled: _ctx.disableForm,
                                type: "text",
                                name: "roleChange",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                onInput: _cache[78] || (_cache[78] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[79] || (_cache[79] = ($event) => (_ctx.v$.formData.roleChange.$touch()))
                            }, null, 40, _hoisted_216),
                            _createTextVNode(),
                            (_ctx.v$.formData.roleChange.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_217, "\n              * " + _toDisplayString(_ctx.v$.formData.roleChange.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.formData?.amendmentType?.includes('Line Manager Change'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_218, [
                        _hoisted_219,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_220, [
                            _hoisted_221,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                id: "orgName-input",
                                value: _ctx.formData.lineManager,
                                disabled: _ctx.disableForm,
                                type: "text",
                                name: "lineManager",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                onInput: _cache[80] || (_cache[80] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[81] || (_cache[81] = ($event) => (_ctx.v$.formData.lineManager.$touch()))
                            }, null, 40, _hoisted_222),
                            _createTextVNode(),
                            (_ctx.v$.formData.lineManager.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_223, "\n              * " + _toDisplayString(_ctx.v$.formData.lineManager.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_224, [
                            _hoisted_225,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                id: "orgName-input",
                                value: _ctx.formData.employeeNumber,
                                disabled: _ctx.disableForm,
                                type: "text",
                                name: "employeeNumber",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                onInput: _cache[82] || (_cache[82] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[83] || (_cache[83] = ($event) => (_ctx.v$.formData.employeeNumber.$touch()))
                            }, null, 40, _hoisted_226),
                            _createTextVNode(),
                            (_ctx.v$.formData.employeeNumber.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_227, "\n              * " + _toDisplayString(_ctx.v$.formData.employeeNumber.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_228, [
                            _hoisted_229,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                id: "orgName-input",
                                value: _ctx.formData.orgName,
                                disabled: _ctx.disableForm,
                                type: "text",
                                name: "orgName",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                onInput: _cache[84] || (_cache[84] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[85] || (_cache[85] = ($event) => (_ctx.v$.formData.orgName.$touch()))
                            }, null, 40, _hoisted_230),
                            _createTextVNode(),
                            (_ctx.v$.formData.orgName.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_231, "\n              * " + _toDisplayString(_ctx.v$.formData.orgName.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _hoisted_232
                    ]))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.formData?.amendmentType?.includes('Location Change'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_233, [
                        _hoisted_234,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_235, [
                            _createElementVNode("div", _hoisted_236, [
                                _hoisted_237,
                                _createTextVNode(),
                                _createElementVNode("select", {
                                    id: "input-new-role-location-site",
                                    value: _ctx.formData.newRoleLocationSite,
                                    disabled: _ctx.disableForm,
                                    name: "newRoleLocationSite",
                                    autocomplete: "newRoleLocationSite",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-600",
                                    onChange: _cache[86] || (_cache[86] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[87] || (_cache[87] = ($event) => (_ctx.v$.formData.newRoleLocationSite.$touch()))
                                }, [
                                    (_ctx.disableForm)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.configData.LOCATIONS, (location) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: location.LOCATIONCODE,
                                                value: `${location.OBJECTNAME} - ${location.LOCATIONCODE}`
                                            }, _toDisplayString(location.DISPLAYNAME), 9, _hoisted_239));
                                        }), 128))
                                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.activeLocations, (location) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: location.LOCATIONCODE,
                                                value: `${location.OBJECTNAME} - ${location.LOCATIONCODE}`
                                            }, _toDisplayString(location.DISPLAYNAME), 9, _hoisted_240));
                                        }), 128))
                                ], 40, _hoisted_238),
                                _createTextVNode(),
                                (_ctx.v$.formData.newRoleLocationSite.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_241, "\n                * " + _toDisplayString(_ctx.v$.formData.newRoleLocationSite.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_242, [
                            _createElementVNode("div", _hoisted_243, [
                                _hoisted_244,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    id: "input-role-location-postcode",
                                    disabled: "",
                                    value: _ctx.formData.locationPostcode,
                                    name: "roleLocationPostcode",
                                    autocomplete: "roleLocationPostcode",
                                    class: "mt-1 p-2 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-600"
                                }, null, 8, _hoisted_245)
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_246, [
                            _hoisted_247,
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "dwpSite",
                                name: "dwpSite",
                                value: _ctx.formData.dwpSite,
                                disabled: _ctx.disableForm,
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                onChange: _cache[88] || (_cache[88] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[89] || (_cache[89] = ($event) => (_ctx.v$.formData.dwpSite.$touch()))
                            }, [
                                _hoisted_249,
                                _createTextVNode(),
                                _hoisted_250
                            ], 40, _hoisted_248),
                            _createTextVNode(),
                            (_ctx.v$.formData.dwpSite.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_251, "\n              * " + _toDisplayString(_ctx.v$.formData.dwpSite.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_252, [
                            _hoisted_253,
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "hybridWorker",
                                name: "hybridWorker",
                                value: _ctx.formData.hybridWorker,
                                disabled: _ctx.disableForm,
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                onChange: _cache[90] || (_cache[90] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[91] || (_cache[91] = ($event) => (_ctx.v$.formData.hybridWorker.$touch()))
                            }, [
                                _hoisted_255,
                                _createTextVNode(),
                                _hoisted_256
                            ], 40, _hoisted_254),
                            _createTextVNode(),
                            (_ctx.v$.formData.hybridWorker.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_257, "\n              * " + _toDisplayString(_ctx.v$.formData.hybridWorker.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.formData?.amendmentType?.includes('Business Structure Change'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_258, [
                        _hoisted_259,
                        _createTextVNode(),
                        _hoisted_260,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_261, [
                            _createElementVNode("textarea", {
                                id: "moreDetails",
                                value: _ctx.formData.moreDetails,
                                name: "moreDetails",
                                rows: "3",
                                class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md",
                                onInput: _cache[92] || (_cache[92] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                            }, null, 40, _hoisted_262)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_263, [
                            _hoisted_264,
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "employeeSeconding",
                                name: "employeeSeconding",
                                value: _ctx.formData.employeeSeconding,
                                disabled: _ctx.disableForm,
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                onBlur: _cache[93] || (_cache[93] = ($event) => (_ctx.v$.formData.employeeSeconding.$touch())),
                                onChange: _cache[94] || (_cache[94] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                            }, [
                                _hoisted_266,
                                _createTextVNode(),
                                _hoisted_267
                            ], 40, _hoisted_265),
                            _createTextVNode(),
                            (_ctx.v$.formData.employeeSeconding.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_268, "\n              * " + _toDisplayString(_ctx.v$.formData.employeeSeconding.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.formData?.amendmentType?.includes('Hours/Work Pattern Change'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_269, [
                        _hoisted_270,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_271, [
                            _hoisted_272,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                id: "currentSalary-input",
                                value: _ctx.formData.currentSalary,
                                disabled: _ctx.disableForm,
                                type: "text",
                                name: "currentSalary",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                onInput: _cache[95] || (_cache[95] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                            }, null, 40, _hoisted_273),
                            _createTextVNode(),
                            (_ctx.v$.formData.currentSalary.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_274, "\n              * " + _toDisplayString(_ctx.v$.formData.currentSalary.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_275, [
                            _hoisted_276,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                id: "newSalary-input",
                                value: _ctx.formData.newSalary,
                                disabled: _ctx.disableForm,
                                type: "text",
                                name: "newSalary",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                onInput: _cache[96] || (_cache[96] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                            }, null, 40, _hoisted_277),
                            _createTextVNode(),
                            (_ctx.v$.formData.newSalary.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_278, "\n              * " + _toDisplayString(_ctx.v$.formData.newSalary.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_279, [
                            _createVNode(_component_WorkingWeek, {
                                data: _ctx.formData.pattern,
                                "disable-form": _ctx.disableForm,
                                onUpdate: _ctx.handleUpdateWorkingHours
                            }, null, 8, ["data", "disable-form", "onUpdate"])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_280, [
                            _hoisted_281,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                id: "hoursPerWeek-input",
                                value: _ctx.formData.hoursPerWeek,
                                disabled: _ctx.disableForm,
                                type: "text",
                                name: "hoursPerWeek",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                onInput: _cache[97] || (_cache[97] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                            }, null, 40, _hoisted_282)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_283, [
                            _hoisted_284,
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "fteHours",
                                name: "fteHours",
                                value: _ctx.formData.fteHours || '',
                                disabled: _ctx.disableForm,
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                onChange: _cache[98] || (_cache[98] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[99] || (_cache[99] = ($event) => (_ctx.v$.formData.fteHours?.$touch()))
                            }, [
                                _hoisted_286,
                                _createTextVNode(),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fteHoursOptions, (opt) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: opt,
                                        value: opt
                                    }, _toDisplayString(opt), 9, _hoisted_287));
                                }), 128))
                            ], 40, _hoisted_285),
                            _createTextVNode(),
                            (_ctx.v$.formData.fteHours?.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_288, "\n              * " + _toDisplayString(_ctx.v$.formData.fteHours?.$errors[0]?.$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_289, [
                            _hoisted_290,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                id: "weeksPerYear-input",
                                value: _ctx.formData.weeksPerYear,
                                disabled: _ctx.disableForm,
                                type: "text",
                                name: "weeksPerYear",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                onInput: _cache[100] || (_cache[100] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                            }, null, 40, _hoisted_291)
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.formData?.amendmentType?.includes('Role & Benefits Change'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_292, [
                        _hoisted_293,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_294, [
                            _hoisted_295,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                id: "jobTitle-input",
                                value: _ctx.formData.jobTitle,
                                disabled: _ctx.disableForm,
                                type: "text",
                                name: "jobTitle",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                onInput: _cache[101] || (_cache[101] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                            }, null, 40, _hoisted_296)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_297, [
                            _hoisted_298,
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "secondment",
                                name: "secondment",
                                value: _ctx.formData.secondment,
                                disabled: _ctx.disableForm,
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                onChange: _cache[102] || (_cache[102] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[103] || (_cache[103] = ($event) => (_ctx.v$.formData.secondment.$touch()))
                            }, [
                                _hoisted_300,
                                _createTextVNode(),
                                _hoisted_301
                            ], 40, _hoisted_299),
                            _createTextVNode(),
                            (_ctx.v$.formData.secondment.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_302, "\n              * " + _toDisplayString(_ctx.v$.formData.secondment.$errors[0].$message), 1))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            (_ctx.formData?.secondment === 'Yes')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_303, [
                                    _hoisted_304,
                                    _createTextVNode(),
                                    _createElementVNode("select", {
                                        id: "secondmentAllowance",
                                        name: "secondmentAllowance",
                                        value: _ctx.formData.secondmentAllowance,
                                        disabled: _ctx.disableForm,
                                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                        onChange: _cache[104] || (_cache[104] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                        onBlur: _cache[105] || (_cache[105] = ($event) => (_ctx.v$.formData.secondmentAllowance.$touch()))
                                    }, [
                                        _hoisted_306,
                                        _createTextVNode(),
                                        _hoisted_307
                                    ], 40, _hoisted_305),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.secondmentAllowance.$error)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_308, "\n                * " + _toDisplayString(_ctx.v$.formData.secondmentAllowance.$errors[0].$message), 1))
                                        : _createCommentVNode("", true),
                                    _createTextVNode(),
                                    (_ctx.formData?.secondmentAllowance === 'Allowance')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_309, [
                                            _hoisted_310,
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_311, [
                                                _createElementVNode("input", {
                                                    id: "allowanceAmount",
                                                    type: "text",
                                                    name: "allowanceAmount",
                                                    value: _ctx.formData.allowanceAmount,
                                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                                    onChange: _cache[106] || (_cache[106] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                                    onBlur: _cache[107] || (_cache[107] = ($event) => (_ctx.v$.formData.allowanceAmount.$touch()))
                                                }, null, 40, _hoisted_312),
                                                _createTextVNode(),
                                                _createElementVNode("select", {
                                                    id: "allowanceAmountCurrency",
                                                    name: "allowanceAmountCurrency",
                                                    value: _ctx.formData?.allowanceAmountCurrency,
                                                    disabled: _ctx.disableForm,
                                                    class: "mt-1 h-10 ml-2 max-w-lg focus:ring-indigo-500 focus:border-indigo-500 shadow-sm sm:max-w-xs sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                                    onChange: _cache[108] || (_cache[108] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                                    onBlur: _cache[109] || (_cache[109] = ($event) => (_ctx.v$.formData.allowanceAmountCurrency.$touch()))
                                                }, [
                                                    _hoisted_314,
                                                    _createTextVNode(),
                                                    _hoisted_315,
                                                    _createTextVNode(),
                                                    _hoisted_316
                                                ], 40, _hoisted_313),
                                                _createTextVNode(),
                                                (_ctx.v$.formData.allowanceAmountCurrency.$error)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_317, "\n                    *\n                    " + _toDisplayString(_ctx.v$.formData.allowanceAmountCurrency.$errors[0].$message), 1))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _createTextVNode(),
                                            (_ctx.v$.formData.allowanceAmount.$error)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_318, "\n                  * " + _toDisplayString(_ctx.v$.formData.allowanceAmount.$errors[0].$message), 1))
                                                : _createCommentVNode("", true)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createTextVNode(),
                                    _hoisted_319,
                                    _createTextVNode(),
                                    _createElementVNode("input", {
                                        id: "secondmentEndDate-input",
                                        value: _ctx.formData.secondmentEndDate,
                                        disabled: _ctx.disableForm,
                                        type: "date",
                                        name: "secondmentEndDate",
                                        autocomplete: "name",
                                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                        onInput: _cache[110] || (_cache[110] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                        onBlur: _cache[111] || (_cache[111] = ($event) => (_ctx.v$.formData.secondmentEndDate.$touch()))
                                    }, null, 40, _hoisted_320),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.secondmentEndDate.$error)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_321, "\n                * " + _toDisplayString(_ctx.v$.formData.secondmentEndDate.$errors[0].$message), 1))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_322, [
                            _hoisted_323,
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "promotion",
                                name: "promotion",
                                value: _ctx.formData.promotion,
                                disabled: _ctx.disableForm,
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                onBlur: _cache[112] || (_cache[112] = ($event) => (_ctx.v$.formData.promotion.$touch())),
                                onChange: _cache[113] || (_cache[113] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                            }, [
                                _hoisted_325,
                                _createTextVNode(),
                                _hoisted_326
                            ], 40, _hoisted_324),
                            _createTextVNode(),
                            (_ctx.v$.formData.promotion.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_327, "\n              * " + _toDisplayString(_ctx.v$.formData.promotion.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        (!_ctx.formData?.amendmentType?.includes('Ad-Hoc'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_328, [
                                _createElementVNode("div", _hoisted_329, [
                                    _hoisted_330,
                                    _createTextVNode(),
                                    _createElementVNode("select", {
                                        id: "accountType",
                                        name: "accountType",
                                        value: _ctx.formData.accountType,
                                        disabled: _ctx.disableForm,
                                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                        onBlur: _cache[114] || (_cache[114] = ($event) => (_ctx.v$.formData.accountType.$touch())),
                                        onChange: _cache[115] || (_cache[115] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                                    }, [
                                        _hoisted_332,
                                        _createTextVNode(),
                                        _hoisted_333
                                    ], 40, _hoisted_331),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.accountType.$error)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_334, "\n                * " + _toDisplayString(_ctx.v$.formData.accountType.$errors[0].$message), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _createTextVNode(),
                        _createElementVNode("fieldset", _hoisted_335, [
                            _hoisted_336,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_337, [
                                _createElementVNode("div", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.retainList, (item) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: item,
                                            class: "flex items-start"
                                        }, [
                                            _createElementVNode("div", _hoisted_338, [
                                                _createElementVNode("input", {
                                                    id: item.replace(' ', '-'),
                                                    value: item,
                                                    name: "retainTC",
                                                    type: "checkbox",
                                                    class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed",
                                                    checked: _ctx.formData?.retainTC?.includes(item),
                                                    disabled: _ctx.disableForm,
                                                    onChange: _cache[116] || (_cache[116] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args)))
                                                }, null, 40, _hoisted_339)
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_340, [
                                                _createElementVNode("label", _hoisted_341, _toDisplayString(item), 1)
                                            ])
                                        ]));
                                    }), 128))
                                ])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("fieldset", _hoisted_342, [
                            _hoisted_343,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_344, [
                                _createElementVNode("div", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.retainList, (item) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: item,
                                            class: "flex items-start"
                                        }, [
                                            _createElementVNode("div", _hoisted_345, [
                                                _createElementVNode("input", {
                                                    id: item.replace(' ', '-'),
                                                    value: item,
                                                    name: "moveTC",
                                                    type: "checkbox",
                                                    class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed",
                                                    checked: _ctx.formData?.moveTC?.includes(item),
                                                    disabled: _ctx.disableForm,
                                                    onChange: _cache[117] || (_cache[117] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args)))
                                                }, null, 40, _hoisted_346)
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_347, [
                                                _createElementVNode("label", _hoisted_348, _toDisplayString(item), 1)
                                            ])
                                        ]));
                                    }), 128))
                                ])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_349, [
                            _hoisted_350,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_351, [
                                _createElementVNode("textarea", {
                                    id: "benifitsAdd",
                                    value: _ctx.formData.benifitsAdd,
                                    name: "benifitsAdd",
                                    rows: "3",
                                    class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md",
                                    onInput: _cache[118] || (_cache[118] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                                }, null, 40, _hoisted_352)
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_353, [
                            _hoisted_354,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_355, [
                                _createElementVNode("textarea", {
                                    id: "benifitsRemove",
                                    value: _ctx.formData.benifitsRemove,
                                    name: "benifitsRemove",
                                    rows: "3",
                                    class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md",
                                    onInput: _cache[119] || (_cache[119] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                                }, null, 40, _hoisted_356)
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_357, [
                            _hoisted_358,
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "healthAndSafetyChange",
                                name: "healthAndSafetyChange",
                                value: _ctx.formData.healthAndSafetyChange,
                                disabled: _ctx.disableForm,
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                onChange: _cache[120] || (_cache[120] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[121] || (_cache[121] = ($event) => (_ctx.v$.formData.healthAndSafetyChange.$touch()))
                            }, [
                                _hoisted_360,
                                _createTextVNode(),
                                _hoisted_361
                            ], 40, _hoisted_359),
                            _createTextVNode(),
                            (_ctx.v$.formData.healthAndSafetyChange.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_362, "\n              * " + _toDisplayString(_ctx.v$.formData.healthAndSafetyChange.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("fieldset", _hoisted_363, [
                            _hoisted_364,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_365, [
                                _createElementVNode("div", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roleUpdateOptions, (item) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: item,
                                            class: "flex items-start"
                                        }, [
                                            _createElementVNode("div", _hoisted_366, [
                                                _createElementVNode("input", {
                                                    id: item.replace(' ', '-'),
                                                    value: item,
                                                    name: "roleUpdate",
                                                    type: "checkbox",
                                                    class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed",
                                                    checked: _ctx.formData?.roleUpdate?.includes(item),
                                                    disabled: _ctx.disableForm,
                                                    onChange: _cache[122] || (_cache[122] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args)))
                                                }, null, 40, _hoisted_367)
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_368, [
                                                _createElementVNode("label", _hoisted_369, _toDisplayString(item), 1)
                                            ])
                                        ]));
                                    }), 128))
                                ])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("fieldset", _hoisted_370, [
                            _hoisted_371,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_372, [
                                _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_373, [
                                        _createElementVNode("div", _hoisted_374, [
                                            _createElementVNode("input", {
                                                id: "confirmation",
                                                value: "TRUE",
                                                name: "confirmation",
                                                type: "checkbox",
                                                class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed",
                                                checked: _ctx.formData?.confirmation?.includes('TRUE'),
                                                disabled: _ctx.disableForm,
                                                onChange: _cache[123] || (_cache[123] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args)))
                                            }, null, 40, _hoisted_375)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_376
                                    ])
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.shouldShowOvertimeRates)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_377, [
                        _createElementVNode("div", null, [
                            _hoisted_378,
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "overtimeRates",
                                name: "overtimeRates",
                                value: _ctx.formData.overtimeRates,
                                disabled: _ctx.disableForm,
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                onChange: _cache[124] || (_cache[124] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[125] || (_cache[125] = ($event) => (_ctx.v$.formData.overtimeRates.$touch()))
                            }, [
                                _hoisted_380,
                                _createTextVNode(),
                                _hoisted_381,
                                _createTextVNode(),
                                _hoisted_382
                            ], 40, _hoisted_379),
                            _createTextVNode(),
                            (_ctx.v$.formData.overtimeRates.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_383, "\n              * " + _toDisplayString(_ctx.v$.formData.overtimeRates.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        (_ctx.formData.overtimeRates === 'Yes')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_384, [
                                _hoisted_385,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_386, [
                                    _createElementVNode("textarea", {
                                        id: "overtimeRatesInfo",
                                        value: _ctx.formData.overtimeRatesInfo,
                                        name: "overtimeRatesInfo",
                                        rows: "3",
                                        class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                        disabled: _ctx.disableForm,
                                        onInput: _cache[126] || (_cache[126] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                        onBlur: _cache[127] || (_cache[127] = ($event) => (_ctx.v$.formData.overtimeRatesInfo.$touch()))
                                    }, null, 40, _hoisted_387)
                                ]),
                                _createTextVNode(),
                                (_ctx.v$.formData.overtimeRatesInfo.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_388, "\n              * " + _toDisplayString(_ctx.v$.formData.overtimeRatesInfo.$errors[0].$message), 1))
                                    : _createCommentVNode("", true),
                                _createTextVNode(),
                                _hoisted_389
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.formData.amendmentType?.includes('Business Structure Change') ||
                    _ctx.formData.amendmentType?.includes('Role & Benefits Change'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_390, [
                        _hoisted_391,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_392, [
                            _hoisted_393,
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "peopleReporting",
                                name: "peopleReporting",
                                value: _ctx.formData.peopleReporting,
                                disabled: _ctx.disableForm,
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                onChange: _cache[128] || (_cache[128] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[129] || (_cache[129] = ($event) => (_ctx.v$.formData.peopleReporting.$touch()))
                            }, [
                                _hoisted_395,
                                _createTextVNode(),
                                _hoisted_396
                            ], 40, _hoisted_394),
                            _createTextVNode(),
                            (_ctx.v$.formData.peopleReporting.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_397, "\n              * " + _toDisplayString(_ctx.v$.formData.peopleReporting.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_398, [
                            _hoisted_399,
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "reportingToNow",
                                name: "reportingToNow",
                                value: _ctx.formData.reportingToNow,
                                disabled: _ctx.disableForm,
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                onChange: _cache[130] || (_cache[130] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[131] || (_cache[131] = ($event) => (_ctx.v$.formData.reportingToNow.$touch()))
                            }, [
                                _hoisted_401,
                                _createTextVNode(),
                                _hoisted_402
                            ], 40, _hoisted_400),
                            _createTextVNode(),
                            (_ctx.v$.formData.reportingToNow.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_403, "\n              * " + _toDisplayString(_ctx.v$.formData.reportingToNow.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        (_ctx.formData.reportingToNow === 'Yes')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_404, [
                                _hoisted_405,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_406, [
                                    _createElementVNode("textarea", {
                                        id: "directReports",
                                        value: _ctx.formData.directReports,
                                        name: "directReports",
                                        rows: "3",
                                        class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md",
                                        onInput: _cache[132] || (_cache[132] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                        onBlur: _cache[133] || (_cache[133] = ($event) => (_ctx.v$.formData.directReports.$touch()))
                                    }, null, 40, _hoisted_407),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.directReports.$error)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_408, "\n                * " + _toDisplayString(_ctx.v$.formData.directReports.$errors[0].$message), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.formData?.amendmentType?.includes('Ad-Hoc'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_409, [
                        _hoisted_410,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_411, [
                            _hoisted_412,
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "adHocAccountType",
                                name: "accountType",
                                value: _ctx.formData.accountType,
                                disabled: _ctx.disableForm,
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                onChange: _cache[134] || (_cache[134] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                            }, [
                                _hoisted_414,
                                _createTextVNode(),
                                _hoisted_415,
                                _createTextVNode(),
                                _hoisted_416
                            ], 40, _hoisted_413)
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]),
            _createTextVNode(),
            (!_ctx.disableForm)
                ? (_openBlock(), _createElementBlock("div", _hoisted_417, [
                    _createElementVNode("button", {
                        disabled: _ctx.v$.$invalid,
                        type: "submit",
                        class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                        onClick: _cache[135] || (_cache[135] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.handleSaveForm && _ctx.handleSaveForm(...args)), ["prevent"]))
                    }, "\n          Next\n        ", 8, _hoisted_418)
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
